<style src="./Analyse.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="analyse">
    <div class="illustration">
      <div class="options">
        <div class="option">
          <button
            type="button"
            class="button-choice button-choice__yes"
            :class="{ 'button-choice__yes__selected': choiceParticipate === true }"
            @click="setParticipate()" >
            Vou participar
          </button>
        </div>

        <div class="option">
          <icon-check
            class="icon participate"
            v-show="choiceParticipate === true" />

          <icon-close
            class="icon noparticipate"
            v-show="choiceParticipate === false" />
        </div>

        <div class="option">
          <button
            type="button"
            class="button-choice button-choice__no"
            :class="{ 'button-choice__no__selected': choiceParticipate === false }"
            @click="setNoParticipate()" >
            Não vou participar
          </button>
        </div>
      </div>
      <icon-participate class="background"/>
    </div>

    <div
      v-if="choiceParticipate === true"
      class="form form-participate">
      <button
        v-if="participate !== true"
        class="btn-success"
        type="button"
        @click="approve">
        <icon-check class="icon" />
        <span class="title">Confirmar Participação</span>
      </button>
    </div>

    <div
      v-if="choiceParticipate === false"
      class="form form-noparticipate">

      <div
        v-if="participate === false"
        class="reason">
        <span class="title">Motivo para não participar</span>
        <span
          class="description">
          {{ declineReason }}
        </span>
      </div>

      <template v-if="participate !== false">
        <span class="description">
          É obrigatrório informar o motivo da não participação do evento
        </span>
        <textbox
          class="input"
          label="Motivo"
          placeholder=""
          v-model="declineReason" />
        <button
          class="button btn-danger"
          type="button"
          @click="decline">
          <icon-check class="icon" />
          <span class="title">Rejeitar Participação</span>
        </button>
      </template>
    </div>

    <!-- <form @submit.prevent="submitForm" class="row">
      <button
        class="aproval-button aprove"
        type="button"
        @click="approve">
        <icon-check class="icon" />
        <span class="title">Aprovar</span>
      </button>

      <div class="reprove-container">
        <textbox
          class="input"
          label="Motivo"
          placeholder=""
          v-model="declineReason" />

        <button
          class="aproval-button reprove"
          type="button"
          @click="decline">
          <icon-close class="icon" />
          <span class="title">Reprovar</span>
        </button>
      </div>
    </form> -->
  </section>
</template>

<script>
import { IconCheck, IconClose, IconParticipate } from '@/components/primitives/icons'
import { Textbox } from '@/components/primitives'

export default {
  name: 'Analyse',
  components: {
    IconCheck,
    IconClose,
    Textbox,
    IconParticipate
  },
  props: {
    stageId: null,
    eventId: null,
    participate: null,
    participateReason: null
  },
  data () {
    return {
      declineReason: '',
      choiceParticipate: null
    }
  },
  mounted () {
    this.choiceParticipate = this.participate
    this.declineReason = this.participateReason
  },
  methods: {
    setParticipate () {
      this.choiceParticipate = true
    },
    setNoParticipate () {
      this.choiceParticipate = false
    },
    async approve () {
      await this.$store.dispatch('Board/ANALYSE_TASK', {
        participate: true,
        participateReason: '',
        stageId: this.stageId,
        eventId: this.eventId
      })
      this.$toasted.success('Evento passou para a nova fase')
    },
    async decline () {
      const isNotValid = !this.declineReason ||
        (
          this.declineReason &&
          (
            this.declineReason.trim() === '' ||
            this.declineReason.length < 5
          )
        )
      if (isNotValid) {
        this.$toasted.error('Deve ser apresentado um motivo válido')
        return
      }
      await this.$store.dispatch('Board/ANALYSE_TASK', {
        participate: false,
        participateReason: this.declineReason,
        stageId: this.stageId,
        eventId: this.eventId
      })
      this.$toasted.success('Evento rejeitado')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/event/analyse/Analyse.vue